/* Meemus Bake Shop – theme behaviour: mobile drawer, scroll reveal, AJAX add-to-cart, toast */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  var menuBtn = document.getElementById('mobile-menu-btn');
  var menuClose = document.getElementById('mobile-menu-close');
  var drawer = document.getElementById('mobile-drawer');
  var backdrop = document.getElementById('mobile-drawer-backdrop');

  if (menuBtn && menuClose && drawer && backdrop) {
    var openMenu = function () {
      drawer.classList.remove('translate-x-full');
      drawer.classList.add('translate-x-0', 'open');
      backdrop.classList.remove('opacity-0', 'pointer-events-none');
      backdrop.classList.add('opacity-100', 'pointer-events-auto');
      drawer.setAttribute('aria-hidden', 'false');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      menuClose.focus();
    };
    var closeMenu = function () {
      drawer.classList.remove('translate-x-0', 'open');
      drawer.classList.add('translate-x-full');
      backdrop.classList.remove('opacity-100', 'pointer-events-auto');
      backdrop.classList.add('opacity-0', 'pointer-events-none');
      drawer.setAttribute('aria-hidden', 'true');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
    };
    menuBtn.addEventListener('click', function () {
      menuBtn.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
    });
    menuClose.addEventListener('click', closeMenu);
    backdrop.addEventListener('click', closeMenu);
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuBtn.getAttribute('aria-expanded') === 'true') closeMenu();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024 && menuBtn.getAttribute('aria-expanded') === 'true') closeMenu();
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealItems = document.querySelectorAll('.reveal, .reveal-scale');
  if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealItems.forEach(function (item, index) {
      item.style.transitionDelay = (Math.min(index % 6, 5) * 70) + 'ms';
      observer.observe(item);
    });
  } else {
    revealItems.forEach(function (item) { item.classList.add('is-visible'); });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(message) {
    var toast = document.getElementById('cart-toast');
    var msg = document.getElementById('toast-message');
    if (!toast || !msg) return;
    msg.textContent = message;
    toast.classList.remove('translate-y-32', 'opacity-0');
    toast.classList.add('translate-y-0', 'opacity-100');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('translate-y-0', 'opacity-100');
      toast.classList.add('translate-y-32', 'opacity-0');
    }, 3500);
  }
  window.meemusToast = showToast;

  /* ---------- Cart count ---------- */
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
        });
        return cart;
      });
  }

  /* ---------- AJAX add to cart (falls back to normal form post) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-meemus-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('opacity-70'); }
    var title = form.getAttribute('data-product-title') || 'Item';
    fetch((window.meemus && window.meemus.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          showToast(res.data.description || res.data.message || 'Could not add to bag');
          return;
        }
        showToast('Added ' + title + ' to your bag!');
        return refreshCount();
      })
      .catch(function () { form.removeAttribute('data-meemus-add'); form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('opacity-70'); } });
  });
})();
